import React, { useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import { Sizes } from '../../constants/Image';
import Image from '../Image';
import classNames from 'classnames';
import { useQuery } from '@apollo/client/react';

const GET_PRODUCT = gql`
  query Product($slug: String!) {
    product(slug: $slug) {
      id
      media {
        id
        urls {
          W100
          W540
          W800
          W1600
        }
      }
    }
  }
`;

export type ProductImageData = {
  id: number;
  urls: {
    W100: string;
    W540: string;
    W800: string;
    W1600: string;
  };
};

export type ProductData = {
  id: string;
  media: ProductImageData[];
};

interface Props {
  productSlug: string;
  containerClassName?: string;
  componentClassName?: string;
}

export default function ProductImages({
  productSlug,
  containerClassName,
  componentClassName,
}: Props) {
  const [activeImage, setActiveImage] = useState<ProductImageData | null>(null);
  const [currentProductSlug, setCurrentProductSlug] = useState('');

  const { data } = useQuery<{ product: ProductData }>(GET_PRODUCT, {
    variables: { slug: productSlug },
    skip: !productSlug,
  });

  useEffect(() => {
    if (productSlug === currentProductSlug || !data?.product) {
      return;
    }

    setCurrentProductSlug(productSlug);

    if (data.product.media && data.product.media.length > 0) {
      setActiveImage(data.product.media[0]);
    }
  }, [productSlug, data, currentProductSlug]);

  if (!data?.product?.media || data.product.media.length === 0) return null;

  const images = data.product.media;

  const thumbs = images.map((image: ProductImageData) => (
    <div
      key={image.id}
      className="cursor-pointer grow-0 shrink-0 border p-1 border-solid border-transparent"
      onClick={() => setActiveImage(image)}
    >
      <Image
        image={image}
        key={image.id}
        defaultSize={Sizes.W100}
        allSizes={[Sizes.W100, Sizes.W540]}
        className={`${activeImage && image.id === activeImage.id ? 'border border-solid border-rgrey-light' : ''} rounded-sm bg-rgrey-lightlight object-cover w-28! h-auto`}
        width="100"
        height="100"
      />
    </div>
  ));

  return (
    <div
      className={classNames(
        `flex flex-col-reverse grow shrink relative md:justify-end`,
        componentClassName,
      )}
    >
      <div
        className={classNames(
          'flex flex-row flex-wrap -mx-1 my-2.5 md:mt-6 md:grow-0 md:shrink-0',
          containerClassName,
        )}
      >
        {thumbs}
      </div>
      <div className="bg-repeat-round flex flex-auto relative justify-start">
        <div className="rounded-sm mx-auto my-0">
          <Image
            className={
              'rounded-sm bg-rgrey-lightlight object-cover w-full h-auto'
            }
            defaultSize={Sizes.W800}
            image={activeImage}
            allSizes={[Sizes.W540, Sizes.W800, Sizes.W1600]}
          />
        </div>
      </div>
    </div>
  );
}
